import React, { useState } from 'react'
import StatusTable from './StatusTable'

const Status = () => {

  return (
        <StatusTable />
  )
}

export default Status